import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { UserPlus, Building2, ChevronDown } from "lucide-react";

export const REGISTER_OPTIONS = [
  {
    label: "User Registration",
    sub: "Residents & members",
    href: "https://erp.synqsmc.com/member-register",
    icon: UserPlus,
    testid: "register-option-user",
  },
  {
    label: "Society Registration",
    sub: "Societies & committees",
    href: "https://erp.synqsmc.com/register",
    icon: Building2,
    testid: "register-option-society",
  },
];

const VARIANT_STYLES = {
  text: "inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700 transition-colors hover:text-blue-600",
  hero: "inline-flex items-center justify-center gap-2 rounded-full border border-dashed border-slate-300 px-8 py-3.5 text-sm font-semibold text-slate-500 transition-all duration-300 hover:border-blue-400 hover:text-blue-600",
};

export const RegisterMenu = ({ label = "Register", sub = null, variant = "text", align = "right", testid = "nav-register-button" }) => {
  const [open, setOpen] = useState(false);

  return (
    <span className="relative inline-block">
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen((v) => !v)}
        className={VARIANT_STYLES[variant]}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <span className="text-left leading-tight">
          {label}
          {sub && <span className="block text-[10px] font-medium text-slate-400">{sub}</span>}
        </span>
        <ChevronDown size={14} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <>
            <button
              type="button"
              data-testid={`${testid}-backdrop`}
              aria-label="Close register menu"
              tabIndex={-1}
              onClick={() => setOpen(false)}
              className="fixed inset-0 z-40 cursor-default bg-transparent"
            />
            <motion.div
              initial={{ opacity: 0, y: 8, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 8, scale: 0.97 }}
              transition={{ duration: 0.18 }}
              className={`absolute z-50 mt-3 w-72 rounded-xl border border-slate-200 bg-white p-2 shadow-xl ${
                align === "center" ? "left-1/2 -translate-x-1/2" : "right-0"
              }`}
              data-testid={`${testid}-menu`}
              role="menu"
            >
              {REGISTER_OPTIONS.map((o) => (
                <a
                  key={o.testid}
                  href={o.href}
                  data-testid={o.testid}
                  role="menuitem"
                  className="flex items-center gap-3 rounded-lg px-4 py-3 transition-colors hover:bg-blue-50"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
                    <o.icon size={16} />
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-slate-800">{o.label}</span>
                    <span className="block text-xs text-slate-400">{o.sub}</span>
                  </span>
                </a>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </span>
  );
};
